import clsx from 'clsx'
import './tabs.scss'

const Tabs = ({ selectedTab, tabs, onClick }) => {
  return (
    <div className="tabs bg-gray-light px-6">
      {tabs.map((tab) => {
        const isActive = selectedTab === tab.id
        return (
          <button
            key={tab.id}
            className={clsx('tab py-3 px-6 font-bold text-sm relative', {
              'text-white-dark': !isActive,
              'text-pink active': isActive,
            })}
            onClick={() => onClick(tab)}
          >
            {tab.name}
          </button>
        )
      })}
    </div>
  )
}

export default Tabs
